import React from "react"

import * as S from "./text-blocks"
import Container from "@mui/material/Container"
import { Grid } from "@mui/material"
import useMediaQuery from "@mui/material/useMediaQuery"
import theme from "../../theme"
import CustomImage from "../../components/custom-image/custom-image.component"

const Hero = ({ block }) => {
  const parse = require("html-react-parser")
  const matches = useMediaQuery(theme.breakpoints.up("lg"))

  return (
    <S.Background>
      <Container maxWidth="lg">
        <S.Columns
          container
          spacing={2}
          alignItems="center"
          justifyContent="center"
        >
          {block.map(({ image }, index) => (
            <Grid item xs={6} key={`${index}-about-images`}>
              <div className="wrapper no-reverse">
                <CustomImage img={image} />
              </div>
            </Grid>
          ))}
        </S.Columns>
      </Container>
    </S.Background>
  )

  // return (
  //   <S.Background>
  //     <Container maxWidth="lg">
  //       {block.map((item, index) => (
  //         <>
  //           {matches ? (
  //             <>
  //               {!item.reverse ? (
  //                 <S.Columns container key={index}>
  //                   <Grid item md={12} md={6}>
  //                     {item.title && <h2>{item.title}</h2>}
  //                     {item.text && <p>{parse(item.text)}</p>}
  //                   </Grid>
  //
  //                   {item.image && (
  //                     <Grid item md={12} md={6}>
  //                       <div className="wrapper no-reverse">
  //                         <CustomImage img={item.image} />
  //                       </div>
  //                     </Grid>
  //                   )}
  //                 </S.Columns>
  //               ) : (
  //                 <S.Columns container key={index}>
  //                   {item.image && (
  //                     <Grid item xs={12} md={6}>
  //                       <div className="wrapper">
  //                         <CustomImage img={item.image} />
  //                       </div>
  //                     </Grid>
  //                   )}
  //
  //                   <Grid item xs={12} md={6}>
  //                     {item.title && <h2>{item.title}</h2>}
  //                     {item.text && <p>{parse(item.text)}</p>}
  //                   </Grid>
  //                 </S.Columns>
  //               )}
  //             </>
  //           ) : (
  //             <>
  //               <S.Columns container key={index}>
  //                 <Grid item md={12} md={6}>
  //                   {item.title && <h2>{item.title}</h2>}
  //                   {item.text && <p>{parse(item.text)}</p>}
  //                 </Grid>
  //
  //                 {item.image && (
  //                   <Grid item md={12} md={6}>
  //                     <div className="wrapper no-reverse">
  //                       <CustomImage img={item.image} />
  //                     </div>
  //                   </Grid>
  //                 )}
  //               </S.Columns>
  //             </>
  //           )}
  //         </>
  //       ))}
  //     </Container>
  //   </S.Background>
  // )
}

export default Hero
